//@flow

import React from 'react';
import { createFragmentContainer, graphql } from 'react-relay';
import { FormattedMessage } from 'react-intl';
import { Button } from 'dibs-elements/exports/Button';
import mobileCheck from 'dibs-client-check/src/mobileCheck';

import { HelpInfo } from './HelpInfo';
import { HowPointsWork } from './HowPointsWork';
import { NextStatusComparison } from './NextStatusComparison';
import { PointsSummary } from './PointsSummary';

import styles from './TpnOverview.scss';

import type { TpnOverview_tradeFirm as TradeFirm } from './__generated__/TpnOverview_tradeFirm.graphql';
import type { TpnOverview_viewer as Viewer } from './__generated__/TpnOverview_viewer.graphql';

type Props = {|
    scrollToBenefitsChart: (e?: SyntheticEvent<*>) => void,
    tradeFirm: TradeFirm,
    viewer: Viewer,
|};

export function TpnOverviewComponent(props: Props) {
    const { scrollToBenefitsChart, tradeFirm, viewer } = props;

    return (
        <React.Fragment>
            <NextStatusComparison
                scrollToBenefitsChart={scrollToBenefitsChart}
                tradeFirm={(tradeFirm: Object)}
                viewer={(viewer: Object)}
            />
            <PointsSummary tradeFirm={(tradeFirm: Object)} viewer={(viewer: Object)} />
            <HowPointsWork />
            <div className={styles.learnAboutRewardsButtonWrapper}>
                <Button
                    dataTn="learn-about-rewards-button"
                    onClick={scrollToBenefitsChart}
                    size={mobileCheck.any() ? 'medium' : 'large'}
                >
                    <FormattedMessage
                        id="abt.rewards.TpnOverview.learnAboutRewards"
                        defaultMessage="learn about trade rewards tiers"
                    />
                </Button>
            </div>
            <HelpInfo viewer={(viewer: Object)} />
        </React.Fragment>
    );
}

export const TpnOverview = createFragmentContainer(TpnOverviewComponent, {
    tradeFirm: graphql`
        fragment TpnOverview_tradeFirm on TradeFirmType {
            ...NextStatusComparison_tradeFirm
            ...PointsSummary_tradeFirm
        }
    `,
    viewer: graphql`
        fragment TpnOverview_viewer on Viewer {
            ...HelpInfo_viewer
            ...NextStatusComparison_viewer
            ...PointsSummary_viewer
        }
    `,
});
